import humanize from 'string-humanize';
export default {
    install(Vue) {
        Object.defineProperties(Vue.prototype, {
            $humanize: { value: humanize }
        });
    }
};
